module.exports = __webpack_public_path__ + "src/assets/img/kitchen_bar2.6c97d94a.jpg";